import { render, staticRenderFns } from "./PolicyGrid.vue?vue&type=template&id=a91e4f6a&scoped=true&"
import script from "./PolicyGrid.vue?vue&type=script&lang=js&"
export * from "./PolicyGrid.vue?vue&type=script&lang=js&"
import style0 from "./PolicyGrid.vue?vue&type=style&index=0&id=a91e4f6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a91e4f6a",
  null
  
)

export default component.exports